import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// Const
import { timeFormat } from '../../const/nuclias/dateFormat';

import dayjs from 'dayjs';

// Service
import AuthService from "../../services/Auth.Organization.service";

const initialState = {};

const initCoTermData = (data) => {
  const newData = {
    ...data,
    expiration: {
      showExecutedCoTrem: (data.lastCoterminationExpirationDate && data.lastCoterminationExpirationDate && data.coTerminationAvailability) ? true : false ,
      showAvailable: (!data.lastCoterminationExpirationDate && !data.lastCoterminationExpirationDate && data.coTerminationAvailability)? true : false,
      showUnavailable: (!data.lastCoterminationExpirationDate && !data.lastCoterminationExpirationDate && !data.coTerminationAvailability)? true : false,
      canDownloadCoTerm: data.lastCoterminationExpirationDate ? true : false,
      canCoTrem: data.coTerminationAvailability ? true : false,
      lastCoterminationDate: (data.lastCoterminationExpirationDate && data.lastCoterminationConvertDate) ? dayjs(data.lastCoterminationConvertDat).format(timeFormat.yDate) : null,
      expirationDate: (data.lastCoterminationExpirationDate && data.lastCoterminationConvertDate) ? dayjs(data.lastCoterminationExpirationDate).format(timeFormat.monthEnglish)+ '.' + dayjs(data.lastCoterminationExpirationDate).format(timeFormat.singleDate): null,
      expirationYear: (data.lastCoterminationExpirationDate && data.lastCoterminationConvertDate) ? dayjs(data.lastCoterminationExpirationDate).year(): null
    }
  }
  return newData
}

const initCalculateData = (data) => {
  const newData = {
    ...data,
    expirationData : data.projectedDate ? dayjs(data.projectedDate).format(timeFormat.yDate) : null
  }
  return newData
}


export const getCoTermData = createAsyncThunk(
  "users/getCoTermData",
  async (id, thunkAPI) => {
    const response = await AuthService.getCoTermData(id);
    if (response.error) {
      return thunkAPI.rejectWithValue(response.error);
    }
    
    return initCoTermData(response.data);
  }
);

export const getCalculateData = createAsyncThunk(
  "users/getCalculateData",
  async (id, thunkAPI) => {
    const response = await AuthService.getCalculateData(id);
    if (response.error) {
      return thunkAPI.rejectWithValue(response.error);
    }
    return initCalculateData(response.data);
  }
);

export const postToCoTerm = createAsyncThunk(
  "users/postToCoTerm",
  async (postData, thunkAPI) => {
    const response = await AuthService.toCoTerm(postData);
    if (response.error) {
      return thunkAPI.rejectWithValue(response.error);
    }
    
    return response.data;
  }
);

export const getDownloadCoTerm = createAsyncThunk(
  "users/getDownloadCoTerm",
  async (id, thunkAPI) => {
    const response = await AuthService.downloadCoTerm(id);
    if (response.error) {
      return thunkAPI.rejectWithValue(response.error);
    }
    return response.data.downloadUrl;
  }
);

const coTerminationSlice = createSlice({
  name: 'coTermination',
  initialState,
  reducers: {
    setInitData(state, action) {
      state.coTermination = action.payload;
    }
  },
  extraReducers: {
    [getCoTermData.fulfilled]: (state, action) => {
      state.coTermination = action.payload;
    },
    [getCalculateData.fulfilled]: (state, action) => {
      state.coTermination.calculate = action.payload;
    }
  }
});

// export const { setInitData } = coTerminationSlice.actions;

export default coTerminationSlice;